import { render, staticRenderFns } from "./ProjectAttendances.vue?vue&type=template&id=004bb49a&"
import script from "./ProjectAttendances.vue?vue&type=script&lang=js&"
export * from "./ProjectAttendances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports